import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import Map from "../components/Map";
import Footer from "../components/Footer";
import { useState } from "react";
import Calculator from "../components/Calculator";

const ContactUsPage = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    setShowCalculator(!showCalculator);
  };

  return (
    <>
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData title="Geo Express | Contact" />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/"],
              ["სერვისები", "services", "/services", true],
              ["სიახლეები", "news", "/news"],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
            ]}
            onCalculatorClick={handleShowCalculator}
          />
          <Calculator
            show={showCalculator}
            onClose={() => setShowCalculator(false)}
          />
          <Map />
          <Footer />
        </LayoutProvider>
      </HelmetProvider>
    </>
  );
};

export default ContactUsPage;
